import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import {
  getFirestore,
  connectFirestoreEmulator,
  enableIndexedDbPersistence,
} from 'firebase/firestore';

// Your web app's Firebase configuration, read from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

// Emulator wiring: opt-in via REACT_APP_USE_FIREBASE_EMULATORS=true so
// developers can run the app against local Auth + Firestore without
// touching prod. Wrapped in try/catch because connect* functions throw
// if called twice (e.g. HMR re-imports this module).
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
  try {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  } catch (err) {
    // ignore re-connect in HMR
  }
  try {
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
  } catch (err) {
    // ignore re-connect in HMR
  }
  // eslint-disable-next-line no-console
  console.info('[firebase] Using local Auth + Firestore emulators');
}

// Offline persistence is incompatible with the emulator (and with the
// multi-tab HMR dev flow), so only enable it in production builds.
if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_USE_FIREBASE_EMULATORS !== 'true'
) {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Firestore persistence failed: Multiple tabs open.');
    } else if (err.code === 'unimplemented') {
      console.warn('Firestore persistence is not supported in this browser.');
    }
  });
}
